<template>
	<div class="scene-wrap display-flex-between">
		<div class="left-part display-flex-between flex-column">
			<div class="top-part display-flex-between">
				<div class="left-part item">
					<span class="bg"></span>
					<span class="title">海岛潜水冲浪装备</span>
				</div>
				<div class="right-part item">
					<span class="bg"></span>
					<span class="title">出境Wi-Fi翻译机</span>
				</div>
			</div>
			<div class="bottom-part item">
				<span class="bg"></span>
				<span class="title">周末游戏天地</span>
			</div>
		</div>
		<div class="center-part item">
			<span class="bg"></span>
			<span class="title">户外拍出大场面</span>
		</div>
		<div class="right-part display-flex-between flex-column">
			<div class="top-part item">
				<span class="bg"></span>
				<span class="title">体验新潮黑科技</span>
			</div>
			<div class="center-part item">
				<span class="bg"></span>
				<span class="title">家庭影院</span>
			</div>
			<div class="bottom-part item">
				<span class="bg"></span>
				<span class="title">记录美好时刻</span>
			</div>
		</div>
    </div>
</template>

<script>
	import Vue from 'vue'
	export default {
		data() {
			return {
				
			}
		},
		methods: {
			
		}
	}
</script>

<style lang="scss">
	.scene-wrap{
		color: #ffffff;
		>.left-part{
			width: 49.5%;
			> .top-part{
				height: 48.9898%;
				.left-part,.right-part{
					width: 48.9898%;
				}
				.left-part > .bg{
					background-image: url('https://resource.tanwuapp.com/FudaHGcK7KY7dVtB5Xm9vO4QOvMc');
				}
				.right-part > .bg{
					background-image: url('https://resource.tanwuapp.com/FjSbSVBk7DKwGlatm7cMrvNxovE9');
				}
			}
			> .bottom-part{
				height: 48.9898%;
				>.bg{
					background-image: url('https://resource.tanwuapp.com/Fs69KQXkgw8vQ1wUytNx_3f5TdCj');
				}
			}
		}
		>.center-part{
			width: 24.25%;
			padding-bottom: 49.5%;
			>.bg{
				background-image: url('https://resource.tanwuapp.com/FjCHcSmz0dDJ8XJKRRgC3kAIAxIo');
			}
		}
		>.right-part{
			width: 24.25%;
			>.top-part{
				height: 48.9898%;
				>.bg{
					background-image: url('https://resource.tanwuapp.com/FvndScKUGXAR1a2joNP0KlOCG9oH');
				}
			}
			.center-part,.bottom-part{
				height: 23.4848%;
			}
			.center-part > .bg{
				background-image: url('https://resource.tanwuapp.com/Fp5D00SMGSHfPY6aPUFCsaZRKLvC');
			}
			.bottom-part > .bg{
				background-image: url('https://resource.tanwuapp.com/FicvG78mhHnsNpTGhFXhohuRk5zP');
			}
		}
		.item{
			position: relative;
			cursor: pointer;
			overflow: hidden;
			&::after{
				content: '';
				position: absolute;
				top: 0;
				right: 0;
				bottom: 0;
				left: 0;
				transition: background .3s;
				z-index: 2;
			}
			> .bg{
				position: absolute;
				top: 0;
				right: 0;
				bottom: 0;
				left: 0;
				// background: url(~@assets/img/bg-test.png) no-repeat center;
				background-position:center; 
				background-repeat: no-repeat;
				background-size: cover;
				transition: transform 1.5s;
			}
			> .title{
				position: absolute;
				left: 0;
				right: 0;
				text-align: center;
				bottom: 25px;
				transform: translateY(50%);
				transition: all .3s ease-out;
				transition-delay: 0.1s;
				z-index: 3;
			}
			&:hover{
				&::after{
					background: rgba($color: #3ED8C4, $alpha: 0.8)
				}
				> .bg{
					transform:scale(1.2);
				}
				> .title{
					font-size: 26px;
					font-weight: bold;
					bottom: 50%;
					@media only screen and (max-width: 1200px) {
						font-size: 22px;
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/sceneBox.vue